import * as React from 'react';
import css from './spinner.module.css';
import { Color } from '../styles/colors';
import cn from '../utils/classnames';

const style = (color, size, strokeWidth, inline) => ({
  borderTop: `${strokeWidth}px solid ${color}`,
  borderRight: `${strokeWidth}px solid ${color}`,
  borderBottom: `${strokeWidth}px solid ${color}`,
  borderLeft: `${strokeWidth}px solid transparent`,
  width: inline ? '1em' : size,
  height: inline ? '1em' : size,
});

type SpinnerProps = {
  color?: string;
  size?: number;
  strokeWidth?: number;
  inline?: boolean;
  className?: string;
};
export default function Spinner({
  color = Color.blinkRed,
  size = 20,
  strokeWidth = 2,
  inline = false,
  className,
}: SpinnerProps) {
  return (
    <div
      className={cn(className, css.spinner, {
        [css.inline]: inline,
      })}
      style={style(color, size, strokeWidth, inline)}
    />
  );
}
